import { defineMessages } from "react-intl";

const messages = defineMessages({
    h2: {
        id: "aboutus.story.h2",
    },
    p: {
        id: "aboutus.story.p",
    },
});

export default messages;
